import { PaymentMethod } from "modules/ClientAccount/utils"
import { Icon } from "components"
import { PaymentIcon } from "components/PaymentIcon"

interface Props {
    card: PaymentMethod | null
}

export function CardOneItem({ card }: Props) {
    return (
        <div className="one-card-item">
            <PaymentIcon cardName={card?.card_type} className="one-card-item__plus-icon" />
            <Icon type="four-dots-unselected" size="28" />
            <div className="one-card-item__last-card-digits">{card?.card_mask?.slice(-4)}</div>
        </div>
    )
}
